import { render } from "./VolumeLoudIcon.vue?vue&type=template&id=571d5d90"
import script from "./VolumeLoudIcon.vue?vue&type=script&lang=js"
export * from "./VolumeLoudIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__